import React from 'react';
import { truncateText, getStatusBadge } from '../utils/employeeUtils';
import { IconButton, TableCell, TableRow, Tooltip, Typography } from '@mui/material';

export const EmployeeTableRow = ({
  employee,
  onEditStatus,
}) => {
  return (
    // <tr className="hover:bg-base-300">
    //   <td className="font-mono text-sm">{employee.EmployeeId}</td>
    //   <td>
    //     <div className="font-medium">{employee.EmployeeName}</div>
    //   </td>
    //   <td className="font-mono text-sm">{employee.EmployeePhone}</td>
    //   <td>
    //     <div className="max-w-xs">
    //       {employee.EmployeeMailId ? (
    //         <a
    //           href={`mailto:${employee.EmployeeMailId}`}
    //           className="link link-primary text-sm"
    //         >
    //           {truncateText(employee.EmployeeMailId, 25)}
    //         </a>
    //       ) : (
    //         <span className="text-base-content/50">-</span>
    //       )}
    //     </div>
    //   </td>
    //   <td>
    //     <div className="max-w-xs">
    //       <span className="text-sm" title={employee.role && employee.role.RoleName ? employee.role.RoleName : ''}>
    //         {truncateText(employee.role && employee.role.RoleName ? employee.role.RoleName : '', 20)}
    //       </span>
    //     </div>
    //   </td>
    //   <td>
    //     <div className="">{getStatusBadge(employee.is_active)}</div>
    //   </td>
    //   <td>
    //     <button
    //       className="btn btn-ghost btn-xs"
    //       onClick={() => onEditStatus && onEditStatus(employee)}
    //     >
    //       <svg
    //         xmlns="http://www.w3.org/2000/svg"
    //         className="h-4 w-4"
    //         fill="none"
    //         viewBox="0 0 24 24"
    //         stroke="currentColor"
    //       >
    //         <path
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //           strokeWidth="2"
    //           d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    //         />
    //       </svg>
    //     </button>
    //   </td>
    // </tr>
    <TableRow hover>
      <TableCell>
        <Typography variant="body2" fontFamily="monospace">
          {employee.EmployeeId}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body1" fontWeight={500}>
          {employee.EmployeeName}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" fontFamily="monospace">
          {employee.EmployeePhone}
        </Typography>
      </TableCell>
      <TableCell>
        {employee.EmployeeMailId ? (
          <Typography variant="body2" component="a" href={`mailto:${employee.EmployeeMailId}`} color="primary" sx={{ textDecoration: 'none' }}>
            {truncateText(employee.EmployeeMailId, 25)}
          </Typography>
        ) : (
          <Typography variant="body2" color="text.disabled">-</Typography>
        )}
      </TableCell>
      <TableCell>
        <Tooltip title={employee.role && employee.role.RoleName ? employee.role.RoleName : ''}>
          <Typography variant="body2">
            {truncateText(employee.role && employee.role.RoleName ? employee.role.RoleName : '', 20)}
          </Typography>
        </Tooltip>
      </TableCell>
      <TableCell>
        {/* getStatusBadge can return a MUI Chip or Badge for best results */}
        {getStatusBadge(employee.is_active)}
      </TableCell>
      <TableCell>
        <IconButton
          size="small"
          onClick={() => onEditStatus && onEditStatus(employee)}
        >
          {/* You can use a Material UI icon here, but keeping your SVG for now */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
            />
          </svg>
        </IconButton>
      </TableCell>
    </TableRow>
  );
};
